module.exports = __webpack_public_path__ + "static/media/ss2.07d6731b.svg";